// removed by extract-text-webpack-plugin
module.exports = {"menu":"_3MmHKIKEj63Gw_-em45IZc","particlesStyle":"ieCn2fb58zQXQVff1QA7X","inTheParticles":"_2LKPVyPhLpHftQA9SCTEl5","disable":"_3TdD4QDl58xnR0rePygJUj _3MmHKIKEj63Gw_-em45IZc","item":"TXt0kdLBMkOr-jCL7gVjb","active":"E0ABQ0_8Utqiy4ehSLjDb"};


//////////////////
// WEBPACK FOOTER
// ../components/menu/styles.module.css
// module id = 402
// module chunks = 0